import Button from "app/components/basic/Button";
import QnACategory, { IQuestionAnswer } from "app/components/composites/Category/QnACategory";
import { useEffect, useState } from "react";
import { Grid } from "semantic-ui-react";
import "./styles.scss";

export interface IToggleTerms {
	expandText: string;
	collapseText: string;
}
interface ISectionProps {
	content: IQuestionAnswer[];
	otherTerms?: IToggleTerms;
}

const CollapsibleOverview = (props: ISectionProps): JSX.Element => {
	const [categoryOpenList, setCategoryOpenList] = useState<boolean[]>([]);

	useEffect(() => {
		const listFromSession: boolean[] = props.content.map((qna: IQuestionAnswer, index: number) => {
			const key = `${qna.category}-${index}`;
			return window.sessionStorage.getItem(key) ? true : false;
		});
		setCategoryOpenList(listFromSession);
	}, [props.content]);

	const atLeastOneClosed: boolean = categoryOpenList.some((isOpen: boolean) => isOpen === false);

	// @TODO: get the correct typedef / declaration
	const toggleAll =
		(openAll: boolean): any =>
		(): void => {
			const updatedList = categoryOpenList.map(() => {
				return openAll;
			});
			setCategoryOpenList(updatedList);

			props.content.map((qna: IQuestionAnswer, index: number) => {
				const key = `${qna.category}-${index}`;
				openAll ? window.sessionStorage.setItem(key, "open") : window.sessionStorage.removeItem(key);
			});
		};

	// @TODO: get the correct typedef / declaration
	const setOpenAtIndex =
		(indexToToggle: number, category: string): any =>
		(): void => {
			const updatedList = categoryOpenList.map((isOpen: boolean, index: number) => {
				if (indexToToggle === index) {
					const key = `${category}-${index}`;
					window.sessionStorage.getItem(key)
						? window.sessionStorage.removeItem(key)
						: window.sessionStorage.setItem(key, "open");
					return !isOpen;
				}
				return isOpen;
			});
			setCategoryOpenList(updatedList);
		};

	return (
		<Grid.Column mobile={12} tablet={12} computer={8} className="overview__section">
			<Grid.Row className="overview__topic-header">
				{props.otherTerms && (
					<Button
						id={`${atLeastOneClosed ? "expand" : "collapse"}-all`}
						name={atLeastOneClosed ? props.otherTerms.expandText : props.otherTerms.collapseText}
						type="link"
						className="overview__expand-button"
						onClick={toggleAll(atLeastOneClosed)}
					/>
				)}
			</Grid.Row>
			<div className="overview__topic-content mt8">
				{props.content.map((qna: IQuestionAnswer, index: number) => {
					return (
						<Grid.Column mobile={12} tablet={12} computer={4} className="no-margin" key={index}>
							<QnACategory
								key={index}
								title={qna.question}
								content={qna.answer}
								largeTitle={true}
								isOpen={categoryOpenList[index]}
								onOpenChange={setOpenAtIndex(index, qna.category)}
							/>
						</Grid.Column>
					);
				})}
			</div>
		</Grid.Column>
	);
};

export default CollapsibleOverview;
